import { render, staticRenderFns } from "./TagsSelector.vue?vue&type=template&id=740f523c&"
import script from "./TagsSelector.vue?vue&type=script&lang=js&"
export * from "./TagsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports